var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelfCheckoutIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    height: "111px",
    viewBox: "0 0 110 111",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SelfCheckoutIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nike-Logo-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SelfCheckoutIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color-/-FOH",
    fill: "#000000",
    x: 0,
    y: 0,
    width: 110,
    height: 111
  }), /*#__PURE__*/React.createElement("text", {
    id: "KSC",
    fontFamily: "Futura-Bold, Futura",
    fontSize: 28,
    fontWeight: "bold",
    fill: "#FEFDFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    y: 98
  }, "KSC")), /*#__PURE__*/React.createElement("g", {
    id: "devices",
    transform: "translate(29.000000, 18.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cashier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7241379,13.7931034 L19.7241379,3.44827586 L3.5862069,3.44827586 L3.5862069,13.7931034 L8.06896552,13.7931034 L8.06896552,9.48275862 C8.06896552,9.00665108 8.4703654,8.62068966 8.96551724,8.62068966 L14.3448276,8.62068966 C14.8399794,8.62068966 15.2413793,9.00665108 15.2413793,9.48275862 L15.2413793,13.7931034 L19.7241379,13.7931034 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "9.86206897 10.3448276 13.4482759 10.3448276 13.4482759 17.2413793 9.86206897 17.2413793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79310345,19.8275862 L1.79310345,22.4137931 L21.5172414,22.4137931 L21.5172414,19.8275862 C21.5172414,19.3514787 21.1158415,18.9655172 20.6206897,18.9655172 L2.68965517,18.9655172 C2.19450333,18.9655172 1.79310345,19.3514787 1.79310345,19.8275862 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79310345,2.5862069 C1.79310345,2.11009935 2.19450333,1.72413793 2.68965517,1.72413793 L20.6206897,1.72413793 C21.1158415,1.72413793 21.5172414,2.11009935 21.5172414,2.5862069 L21.5172414,13.7931034 L23.3103448,13.7931034 L23.3103448,0 L0,0 L0,13.7931034 L1.79310345,13.7931034 L1.79310345,2.5862069 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1034483,33.6206897 C24.6082964,33.6206897 24.2068966,34.0066511 24.2068966,34.4827586 C24.2068966,34.9588662 24.6082964,35.3448276 25.1034483,35.3448276 L25.1034483,33.6206897 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79310345,37.0689655 L13.5002759,37.0689655 C16.6905638,37.0127066 19.7116379,38.445549 21.6068966,40.9137931 C22.6147447,42.2876685 24.2541719,43.1048201 26.0026897,43.1048201 C27.7512074,43.1048201 29.3906346,42.2876685 30.3984828,40.9137931 C32.2926343,38.4470533 35.3113211,37.0143926 38.4997241,37.0689655 L50.2068966,37.0689655 L50.2068966,29.3103448 L1.79310345,29.3103448 L1.79310345,37.0689655 Z M35.862069,31.0344828 L48.4137931,31.0344828 L48.4137931,32.7586207 L35.862069,32.7586207 L35.862069,31.0344828 Z M22.4137931,34.4827586 C22.4137931,33.054436 23.6179927,31.8965517 25.1034483,31.8965517 L25.1034483,31.0344828 L26.8965517,31.0344828 L26.8965517,31.8965517 C28.3820073,31.8965517 29.5862069,33.054436 29.5862069,34.4827586 L27.7931034,34.4827586 C27.7931034,34.0066511 27.3917036,33.6206897 26.8965517,33.6206897 L26.8965517,35.3448276 C28.3820072,35.3448276 29.5862069,36.5027119 29.5862069,37.9310345 C29.5862069,39.3593571 28.3820072,40.5172413 26.8965517,40.5172414 L26.8965517,41.3793103 L25.1034483,41.3793103 L25.1034483,40.5172414 C23.6179927,40.5172414 22.4137931,39.3593571 22.4137931,37.9310345 L24.2068966,37.9310345 C24.2068966,38.407142 24.6082964,38.7931034 25.1034483,38.7931034 L25.1034483,37.0689655 C23.6179927,37.0689655 22.4137931,35.9110812 22.4137931,34.4827586 L22.4137931,34.4827586 Z M3.5862069,31.0344828 L16.137931,31.0344828 L16.137931,32.7586207 L3.5862069,32.7586207 L3.5862069,31.0344828 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8598621,41.9086207 C30.515936,43.7395057 28.3306248,44.8283609 26,44.8283609 C23.6693752,44.8283609 21.484064,43.7395057 20.1401379,41.9086207 C18.5812407,39.8985487 16.107369,38.7377731 13.5002759,38.7931034 L1.79310345,38.7931034 L1.79310345,50 L50.2068966,50 L50.2068966,38.7931034 L38.4997241,38.7931034 C35.892631,38.7377731 33.4187593,39.8985487 31.8598621,41.9086207 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "0 24.137931 52 24.137931 52 27.5862069 0 27.5862069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7931034,37.9310345 C27.7931034,37.4549269 27.3917036,37.0689655 26.8965517,37.0689655 L26.8965517,38.7931034 C27.3917036,38.7931034 27.7931034,38.407142 27.7931034,37.9310345 Z",
    id: "Path",
    fill: "#FFFCFC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "swoosh",
    transform: "translate(56.000000, 28.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.61182835,5.07419385 C5.15107557,5.45860248 3.9978497,5.38172075 3.3827959,4.9204304 C1.69139795,3.6903228 2.99838727,1.2301076 3.45967762,0.46129035 C2.61397865,1.38387105 1.8451614,2.30645175 1.15322587,3.22903245 C0.15376345,4.76666695 -0.3075269,6.4580649 0.384408625,7.53440905 C1.61451622,9.5333339 4.53602177,8.6107532 6.38118317,7.76505423 L23.6795713,0.46129035 L6.61182835,5.07419385 L6.61182835,5.07419385 Z",
    id: "Swoosh-Copy"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelfCheckoutIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/selfCheckoutIcon.3f107e93f06f857c0c77ff2777b705d4.svg";